<template>
  <div class="page">
    <v-card class="pa-1 mt-12 mb-6" max-width="500" elevation="0">
      <v-card-title class="text-h6 font-weight-medium pa-4 pb-2">Сервисное сообщение</v-card-title>
      <v-card-text>
        <v-form v-model="formValid" @submit.prevent="submitForm">
          <v-switch
            v-model="form.switch"
            label="Показать"
            color="primary"
            :true-value="1"
            :false-value="0"
          />

          <v-textarea
            v-model="form.message"
            label="Сообщение"
            required
            :rules="[(v) => !!v || 'Введите сообщение']"
          />

          <v-btn
            :disabled="!formValid || loadingMessage"
            type="submit"
            color="primary"
            class="mt-4"
          >
            Сохранить
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="pa-1" max-width="500" elevation="0">
      <v-card-title class="text-h6 font-weight-medium pa-4 pb-2">Сервис проверки МЧД</v-card-title>
      <v-card-text>
        <v-form @submit.prevent="submitAcp">
          <v-checkbox
            v-model="acpForm.enabled"
            label="Включен"
            color="primary"
            :true-value="1"
            :false-value="0"
            hide-details
          />

          <v-btn :disabled="loadingAcp" type="submit" color="primary" class="mt-4">
            Сохранить
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="pa-1 mt-6 mb-6" max-width="500" elevation="0">
      <v-card-title class="text-h6 font-weight-medium pa-4 pb-2">
        Текст согласия с пользовательским соглашением
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="submitAgreementNotice">
          <v-textarea v-model="agreementForm.text" label="Текст для чекбокса" />

          <v-btn :disabled="loadingAgreement" type="submit" color="primary" class="mt-4">
            Сохранить
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script setup>
import { useStore } from 'vuex'
import { onMounted, ref } from 'vue'
import { useToast } from '@/composables/useToast'
import { api } from '@/api/Api'

const store = useStore()
const { toast } = useToast()

const form = ref({
  switch: 1,
  message: '',
})
const formValid = ref(false)
const loadingMessage = ref(false)

const acpForm = ref({
  enabled: 0,
})
const loadingAcp = ref(false)
const agreementForm = ref({
  text: '',
})
const loadingAgreement = ref(false)

const setPageTitle = () => {
  store.commit('app/setPageTitle', 'Настройки')
}

const submitForm = async () => {
  loadingMessage.value = true

  try {
    await api
      .user()
      .setServiceMessage(form.value)
      .then(() => {
        toast.success('Данные успешно сохранены')
      })
  } catch (err) {
    if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message)
    }
  } finally {
    loadingMessage.value = false
  }
}

const submitAcp = async () => {
  loadingAcp.value = true
  try {
    await api
      .user()
      .setAcp({ enabled: acpForm.value.enabled })
      .then(() => {
        toast.success('Данные успешно сохранены')
      })
  } catch (err) {
    if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message)
    }
  } finally {
    loadingAcp.value = false
  }
}

const getMessage = async () => {
  await api
    .user()
    .getServiceMessage()
    .then((response) => {
      form.value = {
        ...response,
        switch: +response.switch,
      }
    })
}

const getAcp = async () => {
  await api
    .user()
    .getAcp()
    .then((response) => {
      acpForm.value = {
        enabled: +response.enabled ? 1 : 0,
      }
    })
}

const getAgreementNotice = async () => {
  await api
    .user()
    .getAgreementNotice()
    .then((response) => {
      agreementForm.value = {
        text: response?.text ?? '',
      }
    })
}

const submitAgreementNotice = async () => {
  loadingAgreement.value = true
  try {
    await api
      .user()
      .setAgreementNotice({ text: agreementForm.value.text })
      .then(() => {
        toast.success('Данные успешно сохранены')
      })
  } catch (err) {
    if (err?.response?.data?.message) {
      toast.error(err?.response?.data?.message)
    }
  } finally {
    loadingAgreement.value = false
  }
}

onMounted(async () => {
  setPageTitle()
  await Promise.all([getMessage(), getAcp(), getAgreementNotice()])
})
</script>
